import Exception from './exception';

export default class ExceptionUnderMaintenance extends Exception {
  constructor(msg: string | undefined) {
    super(msg);
    Object.setPrototypeOf(this, ExceptionUnderMaintenance.prototype);
  }
}